import {
    Box,
    Text,
    Progress,
    Flex,
} from "@chakra-ui/react";

import Card from "./Card";

const ProgressCard = ({
    title,
    percentage,
    current,
    target,
}) => {
    return (
        <Card>
            <Flex
                justify="space-between"
                mb={5}
            >
                <Text
                    fontWeight="700"
                    color="#071D54"
                >
                    {title}
                </Text>

                <Text
                    color="#2453FF"
                    fontWeight="700"
                >
                    {percentage}%
                </Text>
            </Flex>

            <Progress.Root
                value={percentage}
                size="md"
                borderRadius="full"
            >
                <Progress.Track
                    bg="#E8EEFF"
                >
                    <Progress.Range
                        bg="#2453FF"
                    />
                </Progress.Track>
            </Progress.Root>

            <Flex
                justify="space-between"
                mt={5}
            >
                <Text
                    fontSize="28px"
                    fontWeight="700"
                    color="#071D54"
                >
                    {current}
                </Text>

                <Text
                    color="gray.500"
                    alignSelf="end"
                >
                    of {target}
                </Text>
            </Flex>

            <Text
                mt={4}
                color="gray.500"
                fontStyle="italic"
                fontSize="sm"
            >
                Every approved driver brings you closer to your next payout.
            </Text>
        </Card>
    );
};

export default ProgressCard;